const defaultRule: yakkyo.IFacebookAutomationRule = {
  field: 'campaign$spend',
  operator: 'EQUAL',
  value: '10',
  timeFrame: 'today'
}
export default defaultRule
